export default __webpack_public_path__ + "static/media/r200-7.33643e91.png";